export const checksums = {
  "docs": "v3.3.0--5YcOEpvvkh"
}
export const checksumsStructure = {
  "docs": "bZeci0WYxO"
}

export const tables = {
  "docs": "_content_docs",
  "info": "_content_info"
}

export default {
  "docs": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}